import PropTypes from "prop-types";
import {
    createContext,
    useEffect,
    useCallback,
    useState,
} from "react";
// utils
import localStorageAvailable from "../utils/localStorageAvailable";
//
import { isValidToken, setSession } from "./utils";
import { useMutation } from "@apollo/client";
import { LOGIN_SHADOW_ACCOUNT } from "../graphql/mutations";

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
    children: PropTypes.node,
};

export function AuthProvider({ children }) {
    const [loginShadowAccount] = useMutation(LOGIN_SHADOW_ACCOUNT);
    const [isInitialized, setIsInitialized] = useState(false);

    const storageAvailable = localStorageAvailable();

    const initialize = useCallback(async () => {
        const accessToken = storageAvailable
            ? localStorage.getItem("accessToken")
            : "";

        if (!accessToken || !isValidToken(accessToken)) {
            const res = await loginShadowAccount();
            const accessToken = res?.data?.shadowLogin ?? "";
            setSession(accessToken);
            setIsInitialized(true);
        }
    }, [storageAvailable]);

    useEffect(() => {
        initialize();
    }, [initialize]);


    return (
        <AuthContext.Provider value={isInitialized}>
            {children}
        </AuthContext.Provider>
    );
}
